import React,{ useState } from "react";
import { Link } from "react-router-dom";

const OfferBanner = () => {
    const [showAnnouncement, setShowAnnouncement] = useState(true);
    return (
        <div>
            {/* Announcement Banner */}
         {showAnnouncement && (
          <div className="fixed top-16 left-4 bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center space-x-4 z-50">
            <p>🎉 Get a free website health check! <Link to="/campaigns/free-website-health-check" className="underline">Check now</Link></p>
            <button onClick={() => setShowAnnouncement(false)} className="text-xl font-bold">×</button>
          </div>
        )}  
        </div>
    );
};

export default OfferBanner;